import React from 'react';
import { WithStyles, withStyles, createStyles } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';

import SvgIcon from 'ha/components/SvgIcon';
import { Col, Row, Text, units } from '@ha/dsl';
import { withIntl, IntlProps } from 'ha/i18n';
import { SearchAlert } from './SearchAlerts/SearchAlert';

const styles = createStyles({
  wrapper: {
    margin: units.rem(1.5),
    flexGrow: 2,
  },
  root: {
    padding: units.rem(1),
  },
  sadIcon: {
    marginTop: units.rem(1),
    height: units.rem(5),
  },
});

export const SearchResultsEmpty: React.FC<
  IntlProps & WithStyles<typeof styles>
> = ({ intl: { T }, classes }) => (
  <div className={classes.wrapper}>
    <Row spacing={4}>
      <Col xs={12}>
        <Paper
          classes={{
            root: classes.root,
          }}
        >
          <Row spacing={3}>
            <Col>
              <Text variant="h6" fw="bold">
                {T('search_empty_title')}
              </Text>
            </Col>
          </Row>
          <Row spacing={3}>
            <Col>{T('search_empty_text_search_alert')}</Col>
          </Row>
          <Row spacing={3}>
            <Col>
              <SearchAlert />
            </Col>
          </Row>
        </Paper>
      </Col>
    </Row>
    <Row alignItems="center" justify="center" spacing={4}>
      <Col>
        <SvgIcon name="sad-inbox" className={classes.sadIcon} />
      </Col>
    </Row>
  </div>
);

export default withStyles(styles)(withIntl(SearchResultsEmpty));
